import { BoxxGenericState, getGenericInitialState } from "@boxx/core";
import {
  IStoreCouponsStateError,
  IStoreCouponsStateSuccess,
  StoreCouponsStateType,
} from "@boxx/store-core";
import { ActionReducer, createReducer, on } from "@ngrx/store";
import * as fromCouponsActions from "./store-coupons.actions";

export interface IStoreCouponsState
  extends BoxxGenericState<
    any[],
    IStoreCouponsStateSuccess,
    IStoreCouponsStateError
  > {
  selectedCoupon: any;
}

export const couponsInitialState: IStoreCouponsState = {
  ...getGenericInitialState(),
  data: [],
  selectedCoupon: null,
};

export const storeCouponsReducer: ActionReducer<IStoreCouponsState> =
  createReducer(
    couponsInitialState,
    on(
      fromCouponsActions.loadCouponsBeginAction,
      fromCouponsActions.deleteCouponBeginAction,
      (state): IStoreCouponsState => ({
        ...state,
        isLoading: true,
        error: null,
        success: null,
      })
    ),
    on(
      fromCouponsActions.loadCouponByIdBeginAction,
      fromCouponsActions.createCouponBeginAction,
      fromCouponsActions.updateCouponBeginAction,
      fromCouponsActions.loadSingleCouponBeginAction,
      (state): IStoreCouponsState => ({
        ...state,
        //isLoading: true,
        error: null,
        success: null,
      })
    ),
    on(
      fromCouponsActions.loadCouponsuccessAction,
      fromCouponsActions.deleteCouponSuccessAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: { after: getStoreCouponsActionType(action.type) },
      })
    ),
    on(
      fromCouponsActions.loadCouponByIdSuccessAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        //isLoading: false,
        data: null,
        //selectedCoupon: action.payload,
        error: null,
        success: { after: getStoreCouponsActionType(action.type) },
      })
    ),

    on(
      fromCouponsActions.loadSingleCouponSuccessAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        //isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: { after: getStoreCouponsActionType(action.type) },
      })
    ),

    on(
      fromCouponsActions.loadUpdatedCouponSuccessAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        //isLoading: false,
        fetched: true,
        data: state.data.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...action.payload,
            };
          }
          return item;
        }),
        error: null,
        success: { after: getStoreCouponsActionType(action.type) },
      })
    ),

    on(
      fromCouponsActions.loadCouponByIdSuccessAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        //isLoading: false,
        data: state.data.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...action.payload,
            };
          }
          return item;
        }),
        //selectedCoupon: action.payload,
        error: null,
        success: { after: getStoreCouponsActionType(action.type) },
      })
    ),
    on(
      fromCouponsActions.createCouponSuccessAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        //isLoading: false,
        fetched: true,
        data: action.payload.coupons,
        error: null,
        //success: { after: getStoreCouponsActionType(action.type) },
        success: {
          after: getStoreCouponsActionType(action.type),
          data: action.payload,
        },
      })
    ),
    on(fromCouponsActions.updateCouponSuccessAction, (state, action) =>
      Object.assign({}, state, {
        //isLoading: false,
        fetched: true,
        error: null,
        success: { after: getStoreCouponsActionType(action.type) },
        data: state.data.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...action.payload,
            };
          }
          return item;
        }),
      })
    ),
    on(
      fromCouponsActions.loadCouponsFailAction,
      fromCouponsActions.deleteCouponFailAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        isLoading: false,
        error: {
          after: getStoreCouponsActionType(action.type),
          error: action.errors,
        },
        success: null,
      })
    ),
    on(
      fromCouponsActions.loadCouponByIdFailAction,
      fromCouponsActions.createCouponFailAction,
      fromCouponsActions.updateCouponFailAction,
      fromCouponsActions.loadSingleCouponFailAction,
      (state, action): IStoreCouponsState => ({
        ...state,
        //isLoading: false,
        error: {
          after: getStoreCouponsActionType(action.type),
          error: action.errors,
        },
        success: null,
      })
    ),
    on(fromCouponsActions.clearCouponsuccessErrorDataAction, (state) => ({
      ...state,
      error: null,
      success: null,
    }))
  );

const getStoreCouponsActionType = (
  type: fromCouponsActions.StoreCouponsActionTypes
) => {
  let action: StoreCouponsStateType;

  switch (type) {
    case fromCouponsActions.StoreCouponsActionTypes.loadCouponsSuccess:
    case fromCouponsActions.StoreCouponsActionTypes.loadCouponsFail:
      action = "LOAD_COUPONS";
      break;
    case fromCouponsActions.StoreCouponsActionTypes.createCouponSuccess:
    case fromCouponsActions.StoreCouponsActionTypes.createCouponFail:
      action = "CREATE_COUPON";
      break;
    case fromCouponsActions.StoreCouponsActionTypes.updateCouponSuccess:
    case fromCouponsActions.StoreCouponsActionTypes.updateCouponFail:
      action = "UPDATE_COUPON";
      break;
    case fromCouponsActions.StoreCouponsActionTypes.deleteCouponSuccess:
    case fromCouponsActions.StoreCouponsActionTypes.deleteCouponFail:
      action = "DELETE_COUPON";
      break;
    case fromCouponsActions.StoreCouponsActionTypes.loadSingleCouponSuccess:
    case fromCouponsActions.StoreCouponsActionTypes.loadSingleCouponFail:
      action = "GET_SINGLE_COUPON";
      break;
    default:
      action = "UNKNOWN";
  }

  return action;
};
